
define('text!templates/pages/account-main/file-list.ejs',[],function () { return '<tbody>\n    <tr class="hidden">\n        <td class="file-name">Файлов нет.</td>\n        <td class="file-size"></td>\n    </tr>\n</tbody>\n';});

